<form [formGroup]="formGroup" (ngSubmit)="this.onSubmit()" class="w-full">
  <div class="flex w-full flex-col gap-4">
    <!-- Company dropdown (moved to top) -->
    <div class="p-field w-full">
      <app-drop-down-company
        id="companyOwnerId"
        formControlName="companyOwnerId"
        class="w-full"></app-drop-down-company>
      <p
        *ngIf="formGroup.get('companyOwnerId')?.touched && formGroup.get('companyOwnerId')?.invalid"
        class="mt-1 text-sm text-red-600">
        Seleccione una empresa
      </p>
    </div>

    <!-- URL -->
    <div class="p-field w-full">
      <label for="url" class="mb-1 block text-sm font-medium text-gray-700">URL</label>
      <input id="url" type="text" formControlName="url" pInputText class="p-inputtext w-full" />
      <p *ngIf="formGroup.get('url')?.touched && formGroup.get('url')?.invalid" class="mt-1 text-sm text-red-600">
        URL es requerido
      </p>
    </div>

    <!-- Key -->
    <div class="p-field w-full">
      <label for="identity" class="mb-1 block text-sm font-medium text-gray-700">Identity</label>
      <input id="identity" type="text" formControlName="identity" pInputText class="p-inputtext w-full" />
      <p
        *ngIf="formGroup.get('identity')?.touched && formGroup.get('identity')?.invalid"
        class="mt-1 text-sm text-red-600">
        Identity es requerido
      </p>
    </div>

    <!-- Identity (with view button) -->
    <div class="p-field w-full">
      <label for="identity" class="mb-1 block text-sm font-medium text-gray-700">Key</label>
      <div class="input-with-btn w-full">
        <input id="key" type="text" formControlName="key" pInputText class="p-inputtext flex-1" />
        <button
          type="button"
          [disabled]="this.dynamicDialogConfig.data?.create"
          (click)="toggleIdentityMask('key')"
          class="p-button p-button-sm view-button flex items-center justify-center rounded bg-blue-600 text-white hover:bg-blue-700">
          <i [ngClass]="identityMasked ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
        </button>
      </div>
      <p *ngIf="formGroup.get('key')?.touched && formGroup.get('key')?.invalid" class="mt-1 text-sm text-red-600">
        Key es requerido
      </p>
    </div>

    <!-- Password (with view button) -->
    <div class="p-field w-full">
      <label for="password" class="mb-1 block text-sm font-medium text-gray-700">Password</label>
      <div class="input-with-btn w-full">
        <input id="password" type="text" formControlName="password" pInputText class="p-inputtext flex-1" />
        <button
          type="button"
          [disabled]="this.dynamicDialogConfig.data?.create"
          (click)="toggleIdentityMask('password')"
          class="p-button p-button-sm view-button flex items-center justify-center rounded bg-blue-600 text-white hover:bg-blue-700">
          <i [ngClass]="passwordMasked ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
        </button>
      </div>
      <p
        *ngIf="formGroup.get('password')?.touched && formGroup.get('password')?.invalid"
        class="mt-1 text-sm text-red-600">
        Password es requerido
      </p>
    </div>

    <!-- Buttons (centered) -->
    <div class="actions-center mt-4">
      <p-button (onClick)="this.dynamicDialogRef.close()" severity="secondary" label="Cancelar" [outlined]="true" />
      <p-button
        type="submit"
        [label]="this.dynamicDialogConfig.data?.create ? 'Crear' : 'Actualizar'"
        [disabled]="!this.formGroup.valid" />
    </div>
  </div>
</form>
